export default __webpack_public_path__ + "static/media/SndLowerZGoAcross.85f08a66.mp3";